import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from './locales/en/translation.json';
import esTranslation from './locales/es/translation.json';
import itTranslation from './locales/it/translation.json';
import ptTranslation from './locales/pt/translation.json';
import deTranslation from './locales/de/translation.json';
import frTranslation from './locales/fr/translation.json';
import nlTranslation from './locales/nl/translation.json';
import ruTranslation from './locales/ru/translation.json';
import arTranslation from './locales/ar/translation.json';
import hiTranslation from './locales/hi/translation.json';
import jaTranslation from './locales/ja/translation.json';
import trTranslation from './locales/tr/translation.json';
import koTranslation from './locales/ko/translation.json';
import viTranslation from './locales/vi/translation.json';
import idTranslation from './locales/id/translation.json';
import zhTranslation from './locales/zh/translation.json';
import thTranslation from './locales/th/translation.json';
import faTranslation from './locales/fa/translation.json';
import urTranslation from './locales/ur/translation.json';
import guTranslation from './locales/gu/translation.json';
import teTranslation from './locales/te/translation.json';
import taTranslation from './locales/ta/translation.json';
import mrTranslation from './locales/mr/translation.json';
import daTranslation from './locales/da/translation.json';
import fiTranslation from './locales/fi/translation.json';
import heTranslation from './locales/he/translation.json';
import svTranslation from './locales/sv/translation.json';
import plTranslation from './locales/pl/translation.json';
import enActionReview from './locales/en/action-review.json';
import esActionReview from './locales/es/action-review.json';
import itActionReview from './locales/it/action-review.json';
import ptActionReview from './locales/pt/action-review.json';
import deActionReview from './locales/de/action-review.json';
import frActionReview from './locales/fr/action-review.json';
import nlActionReview from './locales/nl/action-review.json';
import ruActionReview from './locales/ru/action-review.json';
import arActionReview from './locales/ar/action-review.json';
import hiActionReview from './locales/hi/action-review.json';
import jaActionReview from './locales/ja/action-review.json';
import trActionReview from './locales/tr/action-review.json';
import koActionReview from './locales/ko/action-review.json';
import viActionReview from './locales/vi/action-review.json';
import idActionReview from './locales/id/action-review.json';
import zhActionReview from './locales/zh/action-review.json';
import thActionReview from './locales/th/action-review.json';
import faActionReview from './locales/fa/action-review.json';
import urActionReview from './locales/ur/action-review.json';
import guActionReview from './locales/gu/action-review.json';
import teActionReview from './locales/te/action-review.json';
import taActionReview from './locales/ta/action-review.json';
import mrActionReview from './locales/mr/action-review.json';
import daActionReview from './locales/da/action-review.json';
import fiActionReview from './locales/fi/action-review.json';
import heActionReview from './locales/he/action-review.json';
import svActionReview from './locales/sv/action-review.json';
import plActionReview from './locales/pl/action-review.json';

export const DEFAULT_LANGUAGE = 'en';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: { ...enTranslation, action_review: enActionReview } },
      es: { translation: { ...esTranslation, action_review: esActionReview } },
      it: { translation: { ...itTranslation, action_review: itActionReview } },
      pt: { translation: { ...ptTranslation, action_review: ptActionReview } },
      de: { translation: { ...deTranslation, action_review: deActionReview } },
      fr: { translation: { ...frTranslation, action_review: frActionReview } },
      nl: { translation: { ...nlTranslation, action_review: nlActionReview } },
      ru: { translation: { ...ruTranslation, action_review: ruActionReview } },
      ar: { translation: { ...arTranslation, action_review: arActionReview } },
      hi: { translation: { ...hiTranslation, action_review: hiActionReview } },
      ja: { translation: { ...jaTranslation, action_review: jaActionReview } },
      tr: { translation: { ...trTranslation, action_review: trActionReview } },
      ko: { translation: { ...koTranslation, action_review: koActionReview } },
      vi: { translation: { ...viTranslation, action_review: viActionReview } },
      id: { translation: { ...idTranslation, action_review: idActionReview } },
      zh: { translation: { ...zhTranslation, action_review: zhActionReview } },
      th: { translation: { ...thTranslation, action_review: thActionReview } },
      fa: { translation: { ...faTranslation, action_review: faActionReview } },
      ur: { translation: { ...urTranslation, action_review: urActionReview } },
      gu: { translation: { ...guTranslation, action_review: guActionReview } },
      te: { translation: { ...teTranslation, action_review: teActionReview } },
      ta: { translation: { ...taTranslation, action_review: taActionReview } },
      mr: { translation: { ...mrTranslation, action_review: mrActionReview } },
      da: { translation: { ...daTranslation, action_review: daActionReview } },
      fi: { translation: { ...fiTranslation, action_review: fiActionReview } },
      he: { translation: { ...heTranslation, action_review: heActionReview } },
      sv: { translation: { ...svTranslation, action_review: svActionReview } },
      pl: { translation: { ...plTranslation, action_review: plActionReview } },
      // The languages below currently fall back to English copies
    },
    fallbackLng: DEFAULT_LANGUAGE,
    interpolation: { escapeValue: false },
  });

export default i18n;
